import { withModalControlsHook } from 'components/modals/with-modal-controls-hook';
import ClosedButModal from './closed-but-modal';

// @ts-expect-error ClosedBut is not typed
export const [ClosedBut, useCloseButModal] = withModalControlsHook<undefined, boolean>(ClosedButModal);
